<template>
  <div id="app" class="error-application">
    <div class="error-content">
      <div
        style="
          display: grid;
          align-items: center;
          justify-content: center;
          max-width: 300px;
          text-align: center;
          margin-bottom: 20px;
        "
        class="row"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          width="585"
          height="231"
          viewBox="0 0 585 231"
          xml:space="preserve"
          style="
            max-width: 160px;
            margin: 0 auto;
            height: fit-content;
            margin-bottom: 35px;
          "
        >
          <desc>Created with Fabric.js 3.6.6</desc>
          <defs></defs>
          <g transform="matrix(1 0 0 1 293 116)">
            <g style="">
              <g transform="matrix(2.71 0 0 2.71 -0.33 1.12)">
                <path
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: rgb(255, 215, 181);
                    fill-rule: evenodd;
                    opacity: 1;
                  "
                  transform=" translate(-125, -99)"
                  d="M 56 127 C 56 130.866 59.134 134 63 134 H 209 C 212.866 134 216 130.866 216 127 C 216 123.134 212.866 120 209 120 H 203 C 199.134 120 196 116.866 196 113 C 196 109.134 199.134 106 203 106 H 222 C 225.866 106 229 102.866 229 99 C 229 95.134 225.866 92 222 92 H 200 C 203.866 92 207 88.866 207 85 C 207 81.134 203.866 78 200 78 H 136 C 139.866 78 143 74.866 143 71 C 143 67.134 139.866 64 136 64 H 79 C 75.134 64 72 67.134 72 71 C 72 74.866 75.134 78 79 78 H 39 C 35.134 78 32 81.134 32 85 C 32 88.866 35.134 92 39 92 H 64 C 67.866 92 71 95.134 71 99 C 71 102.866 67.866 106 64 106 H 24 C 20.134 106 17 109.134 17 113 C 17 116.866 20.134 120 24 120 H 63 C 59.134 120 56 123.134 56 127 Z M 226 134 C 229.866 134 233 130.866 233 127 C 233 123.134 229.866 120 226 120 C 222.134 120 219 123.134 219 127 C 219 130.866 222.134 134 226 134 Z"
                  stroke-linecap="round"
                />
              </g>
              <g transform="matrix(2.71 0 0 2.71 17.29 -0.23)">
                <path
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: rgb(255, 255, 255);
                    fill-rule: evenodd;
                    opacity: 1;
                  "
                  transform=" translate(-131.5, -98.5)"
                  d="M 92 140 C 79.8497 140 70 130.374 70 118.5 C 70 106.626 79.8497 97 92 97 C 92.5167 97 93.0292 97.0174 93.537 97.0517 C 93.1842 95.0878 93 93.0654 93 91 C 93 72.2223 108.222 57 127 57 C 141.991 57 154.716 66.702 159.239 80.1695 C 160.31 80.0575 161.398 80 162.5 80 C 179.345 80 193 93.4315 193 110 C 193 125.741 180.675 138.727 165 139.978 V 140 H 108.508 M 103.996 140 H 97.0314 H 103.996 Z"
                  stroke-linecap="round"
                />
              </g>
              <g transform="matrix(2.71 0 0 2.71 17.29 -0.23)">
                <path
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: rgb(245, 130, 32);
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform=" translate(-131.5, -98.5)"
                  d="M 92 141.25 C 92.6904 141.25 93.25 140.69 93.25 140 C 93.25 139.31 92.6904 138.75 92 138.75 V 141.25 Z M 93.537 97.0517 L 93.4529 98.2988 L 95.0504 98.4066 L 94.7673 96.8306 L 93.537 97.0517 Z M 159.239 80.1695 L 158.054 80.5674 L 158.372 81.5169 L 159.369 81.4127 L 159.239 80.1695 Z M 165 139.978 L 164.901 138.732 L 163.75 138.824 V 139.978 H 165 Z M 165 140 V 141.25 H 166.25 V 140 H 165 Z M 108.508 138.75 C 107.817 138.75 107.258 139.31 107.258 140 C 107.258 140.69 107.817 141.25 108.508 141.25 V 138.75 Z M 103.996 141.25 C 104.686 141.25 105.246 140.69 105.246 140 C 105.246 139.31 104.686 138.75 103.996 138.75 V 141.25 Z M 97.0314 138.75 C 96.341 138.75 95.7814 139.31 95.7814 140 C 95.7814 140.69 96.341 141.25 97.0314 141.25 V 138.75 Z M 92 138.75 C 80.5128 138.75 71.25 129.657 71.25 118.5 H 68.75 C 68.75 131.091 79.1866 141.25 92 141.25 V 138.75 Z M 71.25 118.5 C 71.25 107.343 80.5128 98.25 92 98.25 V 95.75 C 79.1866 95.75 68.75 105.909 68.75 118.5 H 71.25 Z M 92 98.25 C 92.4886 98.25 92.9731 98.2665 93.4529 98.2988 L 93.6211 95.8045 C 93.0853 95.7684 92.5448 95.75 92 95.75 V 98.25 Z M 94.7673 96.8306 C 94.4275 94.9394 94.25 92.991 94.25 91 H 91.75 C 91.75 93.1399 91.9408 95.2362 92.3067 97.2727 L 94.7673 96.8306 Z M 94.25 91 C 94.25 72.9127 108.913 58.25 127 58.25 V 55.75 C 107.532 55.75 91.75 71.532 91.75 91 H 94.25 Z M 127 58.25 C 141.438 58.25 153.697 67.5936 158.054 80.5674 L 160.424 79.7716 C 155.735 65.8104 142.544 55.75 127 55.75 V 58.25 Z M 159.369 81.4127 C 160.397 81.3052 161.442 81.25 162.5 81.25 V 78.75 C 161.355 78.75 160.223 78.8097 159.109 78.9263 L 159.369 81.4127 Z M 162.5 81.25 C 178.674 81.25 191.75 94.1412 191.75 110 H 194.25 C 194.25 92.7217 180.015 78.75 162.5 78.75 V 81.25 Z M 191.75 110 C 191.75 125.07 179.945 137.532 164.901 138.732 L 165.099 141.224 C 181.406 139.923 194.25 126.411 194.25 110 H 191.75 Z M 163.75 139.978 V 140 H 166.25 V 139.978 H 163.75 Z M 165 138.75 H 108.508 V 141.25 H 165 V 138.75 Z M 103.996 138.75 H 97.0314 V 141.25 H 103.996 V 138.75 Z"
                  stroke-linecap="round"
                />
              </g>
              <g transform="matrix(-2.71 0 0 2.71 50.4 -62.16)">
                <ellipse
                  style="
                    stroke: rgb(245, 130, 32);
                    stroke-width: 2.5;
                    stroke-dasharray: none;
                    stroke-linecap: round;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: none;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  cx="0"
                  cy="0"
                  rx="6.72014"
                  ry="6.64659"
                />
              </g>
              <g transform="matrix(-2.71 0 0 -2.71 -27.43 16.03)">
                <ellipse
                  style="
                    stroke: rgb(245, 130, 32);
                    stroke-width: 2.5;
                    stroke-dasharray: none;
                    stroke-linecap: round;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: none;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  cx="0"
                  cy="0"
                  rx="7"
                  ry="3.5"
                />
              </g>
              <g transform="matrix(-2.71 0 0 -2.71 51.16 16.03)">
                <ellipse
                  style="
                    stroke: rgb(245, 130, 32);
                    stroke-width: 2.5;
                    stroke-dasharray: none;
                    stroke-linecap: round;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: none;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  cx="0"
                  cy="0"
                  rx="7"
                  ry="3.5"
                />
              </g>
              <g transform="matrix(2.71 0 0 2.71 11.19 58.03)">
                <path
                  style="
                    stroke: rgb(245, 130, 32);
                    stroke-width: 2.5;
                    stroke-dasharray: none;
                    stroke-linecap: round;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: none;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform=" translate(-129.25, -120)"
                  d="M 122 120 H 136.5"
                  stroke-linecap="round"
                />
              </g>
              <g transform="matrix(2.71 0 0 2.71 -150.42 -67.59)">
                <path
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-dashoffset: 0;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 4;
                    fill: rgb(245, 130, 32);
                    fill-rule: evenodd;
                    opacity: 1;
                  "
                  transform=" translate(-69.62, -73.65)"
                  d="M 69.1561 60.292 H 57.2101 V 62.668 H 65.6581 L 56.5061 73.756 V 76 H 69.3761 V 73.624 H 60.0041 L 69.1561 62.382 V 60.292 Z M 82.5681 75.576 H 73.8801 V 77.304 H 80.0241 L 73.3681 85.368 V 87 H 82.7281 V 85.272 H 75.9121 L 82.5681 77.096 V 75.576 Z"
                  stroke-linecap="round"
                />
              </g>
            </g>
          </g>
        </svg>
        <span>System Under Maintanance</span>
      </div>
      <button class="error-button" @click="retry">Retry Now</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  methods: {
    retry() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.error-application {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  height: 100vh;
  width: 100vw;
  padding: 2rem;
  box-sizing: border-box;
  text-align: center;
  font-family: "Poppins", "Segoe UI", sans-serif;
}

.error-content {
  max-width: 600px;
}

.error-code {
  font-size: 4rem;
  font-weight: 700;
  color: var(--primary); /* orange to signify warning/maintenance */
  margin: 0;
}

.error-message {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 1rem 0 0.5rem;
}

.error-subtext {
  font-size: 1rem;
  color: #777;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.error-button {
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background-color: var(--primary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  user-select: none;
}

.error-button:hover {
  background-color: var(--primary);
  opacity: 0.8;
}
</style>
